import * as React from 'react';
import TypedSelect from '~/UI/Select/TypedSelect';

export const BASE_SCENARIO_ID = 'base-scenario-id';

interface ScenarioSelectProps {
	disabledScenarioId: string | '';
	selectedScenarioId: string | '';
	scenarios: {
		id: string | null;
		name: string;
	}[];
	onScenarioSelect: (scenarioId: string) => void;
}

export function ScenarioSelect({
	disabledScenarioId,
	selectedScenarioId,
	scenarios,
	onScenarioSelect,
}: ScenarioSelectProps) {
	return (
		<TypedSelect
			className='w-full h-8 px-1 border border-gray-200 rounded-sm font-roboto text-label font-semibold leading-none text-black truncate bg-gray-100 bg-opacity-60 cursor-pointer align-top'
			options={scenarios.map(({ id, name }) => ({
				disabled: id === disabledScenarioId,
				value: id,
				title: name,
			}))}
			value={selectedScenarioId || ''}
			onTypedValueChange={(value) => {
				if (value === '') {
					return;
				}

				onScenarioSelect(value);
			}}
		/>
	);
}
